import axios from "@/libraries/Axios";
import { useLoginStore } from "@/stores/userStore";

const userStore = useLoginStore();

//GET PRODUCT DETAILS
export const getProductDetails = (prodId) => {
    let baseUrl = "/prod/prodInfo?prodId=";
    if (userStore.isLoggedIn()) {
        baseUrl = "/p"+baseUrl;
    }
    return axios.get(baseUrl + prodId +"&regionId="+userStore.userRegion)
}

//FAVORITES
export const addtoFavourites = ({prodId}) => axios.post("/p/user/collection/addOrCancel", prodId)
export const checkIsFavorite = (prodId) => axios.get("/p/user/collection/isCollection?prodId="+prodId)
export const getFavourits = ({current, size}) =>axios.get("/p/user/collection/prods?current="+current+"&size="+size)
//CART
export const getCartCount = () => axios.get("/p/shopCart/prodCount")
export const addToCart = ({basketId, count, prodId, shopId, skuId}) => axios.post("/p/shopCart/changeItem", {basketId, count, prodId, shopId, skuId})

//BUY NOW
export const buyNow = ({byNowInfo}) => axios.post("/p/order/confirm",byNowInfo)

// PRODUCT REVIEWS
export const getProdReviews = ({ prod }) => axios.get("/prodComm/prodCommPageByProd?prodId=" + prod +"&size=3&current=0&evaluate=-1")
export const getProdReviewData = ({ prod }) => axios.get("/prodComm/prodCommData?prodId="+prod)

//SHOP
export const getShopDetails = (shopId) => {
    let baseUrl = "/shopDetail/"
    if (userStore.isLoggedIn()) {
        baseUrl = "/p" + baseUrl;
    }
    return axios.get(baseUrl+shopId+"?regionId="+userStore.userRegion)
}
export const getShopProducts = (shopId, regionId) => axios.get("/prod/tagProdList?shopId="+shopId+"&regionId="+regionId)
export const getProductsInShop = (shopId, regionId, current, size) => axios.get(`/prod/shopProducts?regionId=${regionId}&shopId=${shopId}&current=${current}&size=${size}`)

//TRENDING
export const getTrendingProducts = (regionId, current, size) => axios.get("/prod/trendingProducts?regionId="+regionId+"&current="+current+"&size="+size)

// GET CUSTOMER SERVICE TO-ID TO MALL WEB CHAT (OTHER-CHAT)
export const getShopToId = (shopId) => axios.get("/customerServices/" + shopId)

// VOUCHER RELATED API's
export const collectVoucher = (voucherId) => axios.get("/p/voucher/collect?voucherId="+ voucherId)
export const getUserVouchers = ({isCollected, applyTo = 3}) => axios.get(`/p/voucher/list?isCollected=${isCollected}&regionId=${userStore.userRegion}&applyTo=${applyTo}`)
export const redeemCodeVoucher = (voucherCode) => axios.post("/p/voucher/redeemCodeVoucher",{voucherCode})
export const redeemCollectableVoucher = (voucherId) => axios.post("/p/voucher/redeemCollectableVoucher", { voucherId })
export const checkVoucherEligibility = () => axios.get("/p/campaign/eligibility")